//@flow

import {fetchClearanceProducts} from "../clearance/fetchClearanceProducts";
import Handlebars from "handlebars";

const badgeTemplate = '{{#if clearance}}<div class="product-tile__misc-row" style="justify-content:flex-start">\n' +
    '                <div class="product-tile__detail-rating">\n' +
    '\n' +
    '                </div>\n' +
    '                <div class="product-tile__clearance-badge clearance-badge">Clearance</div>\n' +
    '\n' +
    '            </div>{{/if}}';

const  compiledBadgeTemplate : any = Handlebars.compile(badgeTemplate);


function addClearance(clearanceProducts:number[], productTiles:HTMLElement[]) {
    productTiles.forEach(productTile=>{
            const  productDetailNameElement:?HTMLElement = productTile.querySelector('.product-tile__detail-name');
            if (productDetailNameElement) {
                const productMiscElement = document.createElement('div');
                productMiscElement.innerHTML =
                    compiledBadgeTemplate({'clearance' : clearanceProducts.includes(parseFloat(productTile.dataset.productCode))});
                productDetailNameElement.parentNode
                    && productDetailNameElement.parentNode.insertBefore(productMiscElement, productDetailNameElement);
            }
        })
}

export default async function initClearance(win: WindowProxy) {
    const products: HTMLElement[] = [...win.document.querySelectorAll(`.product-tile`)];
    const productCodes: number[] = products.map((product: HTMLElement) => parseFloat(product.dataset.productCode));
    const wrapper = win.document.querySelector(`.product-search-page-body-wrapper`);
    const userType = wrapper ? wrapper.getAttribute('data-user-type') : null;
    if (userType !== 'MAX_USER') {
        try {
            const clearanceProducts = await fetchClearanceProducts(productCodes);
            if (clearanceProducts && clearanceProducts.length > 0) {
                addClearance(clearanceProducts, products);
            }
        } catch (err) {
            console.error('clearance fetch failed ' + err);
        }
    }
}


// WEBPACK FOOTER //
// ./javascript/product-search-page/clearance/index.js